<app-header *ngIf="data"></app-header>
<app-loader></app-loader>
<div class="main-content bg-light">
<router-outlet></router-outlet>
</div>
<app-footer *ngIf="data"></app-footer>

